import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Tooltip from 'material-ui/Tooltip';
import { TableHead, TableRow, TableCell } from 'material-ui/Table';

const styles = () => ({
  header: {
    textAlign: 'center'
  }
})

export const MaterialHead = ({ lengthUnitSymbol, print }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Signal</TableCell>
        <TableCell>Name</TableCell>
        <TableCell>
          TL Width (
          {lengthUnitSymbol}
          )
        </TableCell>
        <TableCell>
          DIFF Spacing (
          {lengthUnitSymbol}
          )
        </TableCell>
        <TableCell>Simulation Model</TableCell>
        <TableCell>
          <Tooltip title="Characteristic Impedance">
            <span>
              Z
              <sub>0</sub>
              {' '}
              (Ω)
            </span>
          </Tooltip>
        </TableCell>
        <TableCell>
          <Tooltip title="Differential Impedance">
            <span>
              Z
              <sub>diff</sub>
              {' '}
              (Ω)
            </span>
          </Tooltip>
        </TableCell>
        <TableCell>
          <Tooltip title="Propagation Delay">
            <span>
              T
              <sub>pd</sub>
              {' '}
              (ps/in)
            </span>
          </Tooltip>
        </TableCell>
        {!print && <TableCell />}
      </TableRow>
    </TableHead>
  );
}

MaterialHead.propTypes = {
  classes: PropTypes.shape({
    textAlign: PropTypes.string
  }).isRequired,
  lengthUnitSymbol: PropTypes.string.isRequired,
  print: PropTypes.bool
}

MaterialHead.defaultProps = {
  print: undefined,
}

export default  withStyles(styles)(MaterialHead);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/ImpedanceModelingsTable/TableHead.js